/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementStopLotteryResponse } from './EventSceneManagementStopLotteryResponse';

export type EventSceneManagementStopLotteryResponseApiRespoonse = {
    data?: EventSceneManagementStopLotteryResponse;
    status?: EventSceneManagementStopLotteryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementStopLotteryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

